import React, { Component } from 'react';
//styles
import {
    RightBox,
    Wrapper,
    OuterMargin,
    HeaderIcon,
    BackgroundImage,
    Container,
    LeaderboardIconPlaceholder,
    RowTopSliderLine,
    SlideContainer,
    OpacityOverlay,
} from './style';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon } from '../../../Components/Icons/Icons';
//ui
import { Text } from '../../../UI/Text';
//styles
//layouts
import { Column, HoverableLink } from '../../../Layouts';
import { Row } from '../../../Layouts';
//Components
import { ProfileAvatar } from '../../../Components/ProfileAvatar/ProfileAvatar';
//containers
import { Carusel } from '../../../Containers/Caresel/Carusel';
import { handleLoginService } from '../../../../Services/handleLocalStorage';
import BookedUsers from '../../../Containers/BookedUsers';

//ui
import Punch from '../../../../Assets/Icons/icon-background.png';
import { Banner } from '../../../Components/Banner/Banner';
import {
    generateSlugLink,
    getUrlSearchIds,
    displayInfo,
    displayMetric,
    displayTopLeaderboardLabel,
} from '../../../../Utils';
import { getFormattedDateFromTimestamp } from '../../../../Utils/timeConvertorHelper';
import { LeaderboardSummary } from '../../../Components/LeaderboardSummary/LeaderboardSummary';
import { subscribeToWorkout } from '../../../../Services/handleSocketConnection';
import { Loading } from '../../../Containers/WithLoading/Loading';
import { config } from '../../../../Configurations';
import { compose } from 'recompose';
import screenWidthProvider from '../../../Containers/HOCS/ScreenWidthProvider';
import { LeaderboardsActionCreators } from '../../../../Store/ActionCreators/LeaderboardsActionCreators';
import { timeFormats } from '../../../../Constants/timeFormats';

function User({
    fullName,
    type,
    smallImage,
    index,
    metric,
    userMetric,
    id,
    isLive,
    equalRate,
    position,
    workoutCreatedAt: created,
    metaInfo,
    ...props
}) {
    const showCreatedInfo = created => {
        const day = getFormattedDateFromTimestamp(created, timeFormats.DAY_ORDER);
        const months = getFormattedDateFromTimestamp(created, timeFormats.MON);

        return (
            <Row marginLeft={'auto'} marginRight={'11px'} marginTop={'3px'}>
                <Text fontSize={'14'} weight={'300'}>
                    {`${day} ${months}`}
                </Text>
            </Row>
        );
    };

    const getValueInfo = ({ title }) => {
        const liveUserType = getLiveLeaderboardMetric(type);
        const liveUserMetric = props[liveUserType];

        if (title.toUpperCase() === 'KM') {
            return (
                <Text fontSize={'20'} weight={'bold'}>
                    {Number(metric.toFixed(1))}
                </Text>
            );
        }

        return (
            <Text fontSize={'20'} weight={'bold'}>
                {isLive ? displayMetric(type, liveUserMetric, userMetric) : displayMetric(type, metric, userMetric)}
            </Text>
        );
    };

    return (
        <div style={{ padding: '8px' }} className={'user-in-leaderboard'}>
            <Row align={'center'} justify={'space-between'}>
                <Row align={'center'}>
                    <div style={{ display: 'inline-block', width: '10px' }}>
                        <Text fontSize={'16'} weight={'100'} style={{ float: 'right' }}>
                            {equalRate ? '=' : null}
                            {position}
                        </Text>
                    </div>
                    <OuterMargin margin={'0 20px'}>
                        <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${smallImage}`} />
                    </OuterMargin>
                    <HoverableLink
                        to={{
                            pathname: `/${generateSlugLink({
                                name: fullName,
                                id,
                            })}`,
                        }}
                    >
                        <Row align={'center'}>
                            <Text fontSize={'16'} weight={'bold'} wrapText>
                                {fullName}
                            </Text>
                            {index === 1 ? (
                                <OuterMargin margin={'0 10px'}>
                                    <Row align={'baseline'}>
                                        <Icon.Box size={'14x14'}>
                                            <Icon.Trophy />
                                        </Icon.Box>
                                    </Row>
                                </OuterMargin>
                            ) : null}
                        </Row>
                    </HoverableLink>
                </Row>

                {created ? showCreatedInfo(created) : null}

                <Row align={'center'}>{getValueInfo(metaInfo)}</Row>
            </Row>
        </div>
    );
}

User = withRouter(User);

class Slide extends Component {
    constructor(props) {
        super(props);

        if (props.match.params.workoutId) {
            subscribeToWorkout(Number(props.match.params.workoutId), workingData => {
                if (workingData.user.status === 1) this.addActiveUser(workingData);
                else this.removeActiveUser(workingData);
            });
        }

        this.state = {
            workingOut: [],
        };
    }

    addActiveUser = ({ user, workout }) => {
        let userExists = this.state.workingOut.findIndex(_user => _user.user.id === user.id) === -1 ? false : true;

        if (!userExists) {
            let workingOut = [...this.state.workingOut, { user, workout }];
            this.setState({ workingOut });
        } else {
            let index = this.state.workingOut.findIndex(_user => _user.user.id === user.id);
            let workingOut = this.state.workingOut;
            workingOut[index] = { user, workout };
            this.setState({ workingOut });
        }
    };

    removeActiveUser = ({ user }) => {
        let removeIndex = this.state.workingOut.findIndex(_user => _user.user.id === user.id);
        let workingOut = this.state.workingOut;
        workingOut.splice(removeIndex, 1);

        this.setState({ workingOut });
        this.updateUsers(this.props.id);
    };

    updateUsers = leaderboardId => {
        this.props.updateLeaderboardUsers(leaderboardId);
    };

    setEqualUsersRate(users) {
        const mapMetricsToArray = users.map(user => Math.floor(user.metric));
        let _position = 1;
        let _freezePosition = 0;

        return users.map((user, index) => {
            const equalsItems = mapMetricsToArray.filter(metricItem => metricItem === Math.floor(user.metric));

            const nextUser = users[index + 1];

            if (equalsItems.length > 1) {
                const lastItem = equalsItems[equalsItems.length - 1];
                _freezePosition = _position;

                if (nextUser && Math.floor(nextUser.metric) !== lastItem) {
                    _position += equalsItems.length;
                }

                return { ...user, equalRate: true, position: _freezePosition };
            }

            return { ...user, equalRate: false, position: _position++ };
        });
    }

    render() {
        const {
            gradientColor,
            name,
            metric,
            type,
            users,
            background,
            isDarkeningLayerApplied,
            screenWidth,
        } = this.props;
        const usersList = this.setEqualUsersRate(users);
        const { workingOut } = this.state;
        const MetaInfo = detectTypeOfLeaderboard(metric, type, name);
        const LeaderboardIcon = MetaInfo.component;
        const backgroundImage = background ? `${config.baseUrl}/${background}` : gradientColor;

        // return <div></div>
        return (
            <SlideContainer backgroundImage={backgroundImage}>
                <OpacityOverlay isDarkeningLayerApplied={isDarkeningLayerApplied} />
                <Carusel.SliderRow>
                    <RowTopSliderLine>
                        {screenWidth !== 'DESKTOP' ? (
                            <React.Fragment>
                                <Container hideOnMobile />

                                <div style={{ marginTop: '20px' }}>
                                    <Column alignCenter>
                                        <OuterMargin>
                                            <Row>
                                                <Text>{displayTopLeaderboardLabel(this.props)}</Text>
                                            </Row>
                                        </OuterMargin>
                                        <Row>
                                            <Text
                                                wrapText
                                                weight={'bold'}
                                                alignCenter
                                                upperFirestCharacter
                                                fontSize={48}
                                            >
                                                {name}
                                            </Text>
                                        </Row>
                                    </Column>
                                    <OuterMargin>
                                        <Row justify={'center'}>
                                            <Text>{displayInfo(this.props)}</Text>
                                        </Row>
                                    </OuterMargin>
                                </div>

                                <Container>
                                    <LeaderboardIconPlaceholder>
                                        <BackgroundImage src={Punch} />

                                        <HeaderIcon>
                                            <Icon.Box size={'48x48'}>
                                                <LeaderboardIcon />
                                            </Icon.Box>
                                        </HeaderIcon>
                                    </LeaderboardIconPlaceholder>
                                </Container>
                            </React.Fragment>
                        ) : (
                            <div style={{ marginTop: '20px' }} />
                        )}
                    </RowTopSliderLine>
                </Carusel.SliderRow>

                <OuterMargin margin={'20px 0'}>
                    <Carusel.SliderRow>
                        <Row justify={'space-between'}>
                            <Text opacity={0.6} uppercase>
                                Leaderboards
                            </Text>
                            <Text opacity={0.6} uppercase>
                                {MetaInfo.title}
                            </Text>
                        </Row>
                    </Carusel.SliderRow>
                </OuterMargin>

                <Carusel.SliderRow>
                    {usersList.slice(0, 20).map((user, index) => (
                        <User
                            {...user}
                            userMetric={metric}
                            type={type}
                            key={user.id}
                            index={index + 1}
                            metaInfo={MetaInfo}
                        />
                    ))}
                    <BookedUsers workingUsers={usersList} />
                    {workingOut.map(user => (
                        <User
                            isLive={true}
                            userMetric={metric}
                            type={type}
                            {...user.user}
                            {...user.workout}
                            key={user.user.id}
                            metaInfo={MetaInfo}
                        />
                    ))}
                </Carusel.SliderRow>
            </SlideContainer>
        );
    }
}

const mapTempDispatchToProps = (dispatch, ownProps) => ({
    updateLeaderboardUsers(leaderboardId) {
        dispatch(LeaderboardsActionCreators.updateLeaderboardUsersRequest(leaderboardId));
    },
});

Slide = connect(
    null,
    mapTempDispatchToProps,
)(withRouter(Slide));

const getLiveLeaderboardMetric = (type = 0) => {
    switch (type) {
        case 0:
            return;
        case 1:
            return 'total_BPM';
        case 2:
            return 'total_calories';
        case 3:
            return 'total_KG_lifted';
        case 4:
            return 'total_REPS';
        case 5:
            return 'total_time';
        case 6:
            return 'total_distance';
        default:
            return;
    }
};

// TODO: should be on separete file
export function detectTypeOfLeaderboard(metric, type = 0, nameLeaderboard = '') {
    switch (type) {
        case 0: {
            // exrecice
            return {
                title: 'Number',
                component: () => <Icon.Headerate />,
            };
        }

        case 1: {
            // bpm
            return {
                title: 'Heart rate',
                component: () => <Icon.Headerate />,
            };
        }

        case 2: {
            // calories
            return {
                title: 'Calories',
                component: () => <Icon.Calories />,
            };
        }

        case 3: {
            // Kgs / Lbs
            return {
                title: metric ? 'Kgs' : 'Lbs',
                component: () => <Icon.Weight />,
            };
        }
        case 4: {
            // reps
            return {
                title: 'Reps',
                component: () => <Icon.Reps />,
            };
        }
        case 5: {
            // time
            return {
                title: 'Time',
                component: () => <Icon.Time />,
            };
        }
        case 6: {
            // distance
            return {
                title: 'KM',
                component: () => <Icon.Reps />,
            };
        }
        case 7: {
            // workouts
            return {
                title: 'Number',
                component: () => <Icon.Record />,
            };
        }
        case 8: {
            // followers
            return {
                title: 'Number',
                component: () => null,
            };
        }
        case 9: {
            // repeats
            return {
                title: 'Number',
                component: () => <Icon.Repeat />,
            };
        }
        case 10: {
            // likes
            return {
                title: 'Number',
                component: () => <Icon.Hype />,
            };
        }
        case 11: {
            // comments
            return {
                title: 'Number',
                component: () => <Icon.Record />,
            };
        }

        default: {
            return {
                title: nameLeaderboard,
                component: () => <Icon.Record />,
            };
        }
    }
}

class LeaderBoardsCarusel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentSliderIndex: 0,
        };
    }
    componentDidMount() {
        this.props.getLeaderboardsByIds();
    }

    updateUsers = leaderboardId => {
        this.props.updateLeaderboardUsers(leaderboardId);
    };

    getCurrentSlide = index => {
        this.setState({ currentSliderIndex: index });
    };

    renderSlider = (board, index) => {
        const { background, isDarkeningLayerApplied, screenWidth } = this.props;
        return (
            <div key={board.id} data-index={index} className={'slide-wrapper'}>
                <Slide
                    background={background}
                    isDarkeningLayerApplied={isDarkeningLayerApplied}
                    {...board}
                    metric={this.props.userMetric}
                    users={board.users}
                    screenWidth={screenWidth}
                />
            </div>
        );
    };

    render() {
        const {
            profileImage,
            profileName,
            profileId,
            userType,
            slides,
            areLeaderboardsForSliderLoading,
            background,
            screenWidth,
        } = this.props;
        const { currentSliderIndex } = this.state;

        const isLoading = areLeaderboardsForSliderLoading || slides.length === 0 || userType === undefined;

        return (
            <Wrapper style={{ overflow: 'hidden', position: 'relative' }}>
                <RightBox>
                    <Loading isLoading={isLoading}>
                        <LeaderboardSummary
                            screenWidth={screenWidth}
                            image={profileImage}
                            name={profileName}
                            id={profileId}
                            userType={userType}
                            sliderInfo={slides[currentSliderIndex]}
                            hideDefault={background}
                        />
                        <Carusel
                            getCurrentSlide={this.getCurrentSlide}
                            duration={8000}
                            transition={0.5}
                            killSlider={this.props.killSlider}
                        >
                            {this.props.carusels_boards.map(this.renderSlider)}
                        </Carusel>
                    </Loading>
                </RightBox>
                <Banner />
            </Wrapper>
        );
    }
}

LeaderBoardsCarusel.defaultProps = {
    userType: 'GYM',
};

const mapStateToProps = ({ user, leaderboards, profile }, ownProps) => {
    const selectedIds = ownProps.currentLbIds
        ? Array.from(ownProps.currentLbIds)
        : Array.from(
              getUrlSearchIds(ownProps.location.search)
                  .split(',')
                  .map(id => parseInt(id)),
          );

    const slides = [];
    Object.values(leaderboards.leaderboardsSlider).forEach(lb => {
        if (selectedIds.includes(lb.id)) {
            const _slide = Object.assign({}, lb);
            slides.push(_slide);
        }
    });

    return {
        name: user.currentUser.fullName,
        image: user.currentUser.smallImage,
        id: handleLoginService.getUserId(),
        userType: profile.currentProfile.type,
        carusels_boards: slides,
        users: [],
        slides,
        leaderboardsSlider: leaderboards.leaderboardsSlider,
        areLeaderboardsForSliderLoading: leaderboards.statuses.areLeaderboardsForSliderLoading,
        profileName: profile.currentProfile.fullName,
        profileId: profile.currentProfile.id,
        profileImage: profile.currentProfile.smallImage,
        userMetric: user.currentUserPreferences.metric,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const selectedIds = ownProps.currentLbIds
        ? Array.from(ownProps.currentLbIds)
        : Array.from(getUrlSearchIds(ownProps.location.search).split(','));

    return {
        updateLeaderboardUsers(leaderboardId) {
            dispatch(LeaderboardsActionCreators.updateLeaderboardUsersRequest(leaderboardId));
        },
        getLeaderboardsByIds() {
            dispatch(LeaderboardsActionCreators.getLeaderboardsForSliderRequest(selectedIds));
        },
        killSlider() {
            dispatch({ type: 'KILL_CARUSEL' });
        },
    };
};

export default compose(
    screenWidthProvider,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(LeaderBoardsCarusel);



// WEBPACK FOOTER //
// ./src/UI/App/pages/LeaderBoardsCarusel/LeaderBoardsCarusel.js